// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2060":"49739be3980ab5767553","2331":"137b680fef000016c4aa","4406":"27c17efd5936fd54b53f","7302":"fb5e5fa23279f20ed0c5","9632":"50f3c3cb14addc4ebb10"}[chunkId] + ".css";
};